<form class="row g-3" (ngSubmit)="salvarTerminal()">
  <app-painel-dados-terminal
    class="row g-3"
    [empregadores]="empregadores"
    [departamentos]="departamentos"
    [empregadorSelecionado]="empregadorSelecionado"
    [terminal]="terminal"
    [importando]="importando"
    [ligandoFoto]="ligandoFoto"
    (empregadorSelecionadoChange)="selecionarEmpregador($event)"
    (terminalChange)="alterarTerminal($event)"
    (importarServidores)="importarServidoresControlId()"
    (ligarFotoMonitor)="ligarFotoMonitorControlId()">
  </app-painel-dados-terminal>

  <div class="col-12">
    <app-rodape-crud
      [exibirExcluir]="true"
      [excluirDesabilitado]="!terminal.id"
      (excluir)="excluirTerminal()"
      (limpar)="limparTerminal()"
      (salvar)="salvarTerminal()">
    </app-rodape-crud>
  </div>
</form>

<app-grade-terminais-relogio
    [terminais]="terminais"
    [departamentos]="departamentos"
    (editar)="selecionarTerminal($event)"
  (revogar)="revogarTerminalAtivacao($event)">
</app-grade-terminais-relogio>
